
export const MenuRoutes =[
    //Admin Operator Employee  are the 3 types of roles
    {
        to:"/membresias",
        title:'Membresias',
        private:true,
        //roles: ["Admin", "Employee", "Operator"],
    },
    {
        to:"/archivo-digital",
        title:'Archivo Digital',
        private:true,
        //roles: ["Admin", "Employee", "Operator"],
    },
    {
        to:"/historico",
        title:'Historico Membresias',
        private:true,
        //roles: ["Admin", "Employee", "Operator"],
    },
    {
        to:"/inactivo",
        title:'Personal Inactivo',
        private:true,
        //roles: ["Admin"],
    }
];